import React, { ReactNode, useState } from "react";

export const UiContext = React.createContext({
  showNewNotification: (
    type: "error" | "string" | "info",
    message: string
  ) => {},
});

const UIProvider = (props: { children: ReactNode }) => {
  const [showNotification, setShowNotification] = useState(false);
  const [notification, setNotification] = useState({
    type: "error",
    message: "error here...",
  });

  const showNewNotification = (
    type: "error" | "string" | "info",
    message: string
  ) => {
    if (!message) return;
    setNotification({ type, message });
    setShowNotification(true);
  };

  const closeNotification = () => {
    setShowNotification(false);
  };

  let toast;

  if (notification.type === "error") {
    toast = (
      <div className={`toast ${"toast--error"} `}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="toast--icon"
        >
          <path
            d="M13.0959 5.19349C12.9926 5.0062 12.8356 4.84902 12.6422 4.73927C12.4489 4.62952 12.2266 4.57144 12 4.57144C11.7734 4.57144 11.5511 4.62952 11.3578 4.73927C11.1644 4.84902 11.0074 5.0062 10.9041 5.19349L4.13172 17.7707C4.03727 17.9447 3.99229 18.1383 4.00108 18.3331C4.00986 18.5278 4.07211 18.7172 4.18192 18.8833C4.29172 19.0494 4.44543 19.1868 4.62845 19.2821C4.81147 19.3776 5.01772 19.428 5.22762 19.4286H18.7724C18.9823 19.428 19.1886 19.3776 19.3715 19.2821C19.5546 19.1868 19.7083 19.0494 19.8181 18.8833C19.9279 18.7172 19.9902 18.5278 19.9989 18.3331C20.0078 18.1383 19.9627 17.9447 19.8683 17.7707L13.0959 5.19349Z"
            stroke="#5C5F6A"
            strokeWidth="1.43"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="toast--icon"
          />
          <path
            d="M12 9.9592V13.3878"
            stroke="#5C5F6A"
            strokeWidth="1.43"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="toast--icon"
          />
          <path
            d="M12.0001 16.6531C11.8198 16.6531 11.6736 16.5069 11.6736 16.3265C11.6736 16.1462 11.8198 16 12.0001 16"
            stroke="#5C5F6A"
            strokeWidth="1.43"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="toast--icon"
          />
          <path
            d="M12.0001 16.6531C12.1805 16.6531 12.3267 16.5069 12.3267 16.3265C12.3267 16.1462 12.1805 16 12.0001 16"
            stroke="#5C5F6A"
            strokeWidth="1.43"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="toast--icon"
          />
        </svg>

        <p>{notification.message}</p>

        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={closeNotification}
          className="close-icon"
        >
          <path
            d="M17 7L7 17"
            stroke="#5C5F6A"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 7L17 17"
            stroke="#5C5F6A"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  }

  if (notification.type === "success") {
    toast = (
      <div className="toast toast--success">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="toast--icon"
        >
          <path
            d="M21 6L9.3125 18L4 12.5455"
            stroke="#5C5F6A"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="toast--icon"
          />
        </svg>

        <p>{notification.message}</p>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={closeNotification}
          className="close-icon"
        >
          <path
            d="M17 7L7 17"
            stroke="#5C5F6A"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 7L17 17"
            stroke="#5C5F6A"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  }

  if (notification.type === "info") {
    toast = (
      <div className="toast toast--info">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="toast--icon"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604ZM12 4.5602C10.0268 4.5602 8.1345 5.34403 6.73927 6.73927C5.34403 8.1345 4.5602 10.0268 4.5602 12C4.5602 13.9732 5.34403 15.8655 6.73927 17.2607C8.1345 18.656 10.0268 19.4398 12 19.4398C13.9732 19.4398 15.8655 18.656 17.2607 17.2607C18.656 15.8655 19.4398 13.9732 19.4398 12C19.4398 10.0268 18.656 8.1345 17.2607 6.73927C15.8655 5.34403 13.9732 4.5602 12 4.5602Z"
            fill="#5C5F6A"
            className="toast--icon"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7801 10.5876V16.5739H11.2199V10.5876H12.7801Z"
            fill="#5C5F6A"
            className="toast--icon"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7134 8.2062C12.7563 8.10956 12.7801 8.00259 12.7801 7.89005C12.7801 7.45921 12.4308 7.10995 12 7.10995C11.7093 7.10995 11.4304 7.22545 11.2248 7.43103C11.0192 7.63662 10.9037 7.91546 10.9037 8.2062C10.9037 8.49694 11.0192 8.77578 11.2248 8.98137C11.4304 9.18695 11.7093 9.30245 12 9.30245C12.4308 9.30245 12.7801 8.95319 12.7801 8.52235C12.7801 8.40981 12.7563 8.30284 12.7134 8.2062Z"
            fill="#5C5F6A"
            className="toast--icon"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2199 7.89005C11.2199 7.45921 11.5692 7.10995 12 7.10995C12.2907 7.10995 12.5696 7.22545 12.7752 7.43103C12.9808 7.63662 13.0962 7.91546 13.0962 8.2062C13.0962 8.49694 12.9808 8.77578 12.7752 8.98137C12.5696 9.18695 12.2907 9.30245 12 9.30245C11.5692 9.30245 11.2199 8.95319 11.2199 8.52235C11.2199 8.40981 11.2437 8.30284 11.2866 8.2062C11.2437 8.10956 11.2199 8.00259 11.2199 7.89005Z"
            fill="#5C5F6A"
            className="toast--icon"
          />
        </svg>

        <p>{notification.message}</p>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={closeNotification}
          className="close-icon"
        >
          <path
            className="toast--icon"
            d="M17 7L7 17"
            stroke="#5C5F6A"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            className="toast--icon"
            d="M7 7L17 17"
            stroke="#5C5F6A"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  }
  return (
    <UiContext.Provider value={{ showNewNotification }}>
      {showNotification && toast}
      {props.children}
    </UiContext.Provider>
  );
};

export default UIProvider;
